import React from 'react'
import { CardMedia, Typography, TableCell, IconButton, Box, Tooltip, useTheme, useMediaQuery } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { K1Information } from '@e3dc-react/icons'

interface BasicSystemTableProductProps {
  productImage: string
  productName: string
  productDescription: string
}

interface StyleProps {
  downSm: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  productContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '300px',
    minWidth: '300px',
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      maxWidth: '220px',
      minWidth: 0,
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  productTitle: {
    marginLeft: '12px',
    minWidth: props.downSm ? 'auto' : '160px',
    width: '100px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  productImage: {
    width: '80px',
    height: 'auto',
  },
}))

const BasicSystemTableProduct: React.FC<BasicSystemTableProductProps> = ({ productImage, productName, productDescription }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const { classes } = useStyles({ downSm })

  return (
    <TableCell sx={{ border: 'none' }} className={classes.productContainer}>
      <CardMedia className={classes.productImage} component="img" image={productImage} alt={productName} />
      <Box className={classes.titleContainer}>
        <Typography variant="h3" className={classes.productTitle}>
          {productName}
        </Typography>
        <Tooltip placement="right" title={<div dangerouslySetInnerHTML={{ __html: productDescription }} />}>
          <IconButton color="inherit">
            <K1Information />
          </IconButton>
        </Tooltip>
      </Box>
    </TableCell>
  )
}

export default BasicSystemTableProduct
